<template>
    <button type="button" :class="actionClass" :style="actionStyle" :disabled="disabled"
            v-on:click="onClick">
        <font-awesome-icon :icon="action.on.icon" size="sm" :class="{'mr-2':!action.compact}" v-if="action.on.icon && isToggled"/>
        <font-awesome-icon :icon="action.off.icon" size="sm" :class="{'mr-2':!action.compact}" v-if="action.off.icon && !isToggled"/>
        <template v-if="!action.compact">{{ actionLabel }}</template>
    </button>
</template>

<script>
export default {
    name: "ToggleAction",
    props: {
        action: {type: Object, default: null},
        disabled: {type: Boolean, default: undefined},
        forwardEvents: {type: Boolean, default: false},
        toggled: {type: Boolean, default: null},
        parameterData: {type: Object, default: null},
    },
    data() {
        return {
            isToggled: null,
        }
    },
    computed: {
        actionClass: function () {
            if (this.isToggled) {
                return 'btn btn-sm ' + (this.action.on.class ? this.action.on.class : this.action.class);
            } else {
                return 'btn btn-sm ' + (this.action.off.class ? this.action.off.class : this.action.class);
            }
        },
        actionLabel: function () {
            if (this.isToggled) {
                if (this.parameterData && ('labelfield' in this.action.on) && (this.action.on.labelfield in this.parameterData))
                    return this.parameterData[this.action.on.labelfield];
                else
                    return this.action.on.label ? this.action.on.label : this.action.label;
            } else {
                if (this.parameterData && ('labelfield' in this.action.off) && (this.action.off.labelfield in this.parameterData))
                    return this.parameterData[this.action.off.labelfield];
                else
                    return this.action.off.label ? this.action.off.label : this.action.label;
            }
        },
        actionStyle: function () {
            if (this.isToggled) {
                return this.action.on.style ? this.action.on.style : this.action.style;
            } else {
                return this.action.off.style ? this.action.off.style : this.action.style;
            }
        },
    },
    created() {
        if (this.toggled != null) {
            this.isToggled = !!this.toggled;
        } else if (this.parameterData && ('toggledfield' in this.action) && (this.action.toggledfield in this.parameterData)) {
            this.isToggled = !!this.parameterData[this.action.toggledfield];
        } else if ('toggled' in this.action) {
            this.isToggled = !!this.action.toggled;
        }
        this.action.toggled = this.isToggled;
        if ('createdevent' in this.action) {
            this.emitEvent(this.action.createdevent, this.action);
        }
    },
    methods: {
        emitEvent(event, data) {
            if (this.forwardEvents) {
                this.$emit('forward-event', {
                    event: event,
                    data: data,
                });
            } else {
                this.$emit(event, data);
            }
        },
        onClick(event) {
            if (!this.action.allowpropation) {
                event.preventDefault();
                event.stopPropagation();
            }
            this.isToggled = !this.isToggled;
            this.action.toggled = this.isToggled;
            let newEvent = this.action.event ? this.action.event : this.action.name;
            this.emitEvent(newEvent, this.action);
        },
    }
}
</script>

<style scoped>
</style>
